import * as React from 'react';
import styled, {css} from "styled-components";
import IButtonProps from './types';
import {transition} from "helpers/css";

const Container = styled.button<{active: boolean}>`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 12px;
  align-items: center;
  padding: 0 24px;
  height: 44px;
  width: max-content;
  background-color: transparent;
  border: 1px solid #7B7B7B;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: none;
  
  ${transition()};
  
  svg {
    path {
      fill: #7B7B7B;
      transition: fill .22s;
    }
  }
  
  &:hover {
    box-shadow: 3px 8px 20px rgba(50, 100, 239, 0.4);
    border-color: #3264EF;
    background-color: #3264EF;
  }
  
  ${({active}) => active && css`
    box-shadow: 3px 8px 20px rgba(50, 100, 239, 0.4);
    border-color: #3264EF;
    background-color: #3264EF;
    
    &:hover {
      svg path {
        fill-opacity: 1;
      }
    }
  `}
`

export default function ButtonDone(props: IButtonProps): React.ReactElement {
  const {text, icon, active} = props;

  function clickHandler() {
    props.onClick && props.onClick();
  }

  return (
    <Container
      active={active}
      onClick={clickHandler}
    >
      {text}
      {active && icon || null}
    </Container>
  );
}